export default "__VITE_ASSET__DN5C5HyU__"